import type Player from "@vimeo/player";

// When the browser's autoplay policy blocks playback (e.g. a lesson opened
// from an external link with no click), the video stays paused until the
// student presses play, so that rejection isn't an error.
export default async function playVimeoVideo(player: Player): Promise<void> {
  try {
    await player.play();
  } catch (error) {
    if ((error as Error | undefined)?.name !== "NotAllowedError") {
      throw error;
    }
  }
}
